import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  // Global array to store breadcrumb trail
  private breadcrumbTrail: string[] = [];

  constructor() { }

}
//TODO- Add remaining page names here to handle active page in breadcrumbs
export enum pageName {
  Create_RFQ_Summary = 'Create RFQ Summary',
  RFQ = 'Request for Quotation',
  CCC = 'Corporate Credit Card',
  My_Document = 'My Documents',
  My_worklist = 'My Worklist',
  PE_Worklist = 'PE Worklist',
  Tender = 'Tender',
  DC = 'Direct Contracting',
  Permissible_Reason = 'Permissible Reasons',
  Purchase_mode = 'Purchase Modes',
  RFQ_Summary_Report = 'RFQ Summary Report',
  RFQ_Summary = 'RFQ Summary',
}